import { Injectable } from "@angular/core";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { MapperUtente } from "@app/shared/mapper/mapper-utente";
import { env } from "@env/environment";
import { ModaleErroreStore } from "@app/shared/store/modale-errore.store";
import { catchError, map } from "rxjs/operators";
import {
  throwError as observableThrowError,
  Observable,
  BehaviorSubject
} from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { UtenteDTO } from "../dto/utenteDTO";

@Injectable({
  providedIn: "root"
})
export class ProfiliService {
  private urlUtentiProfilo = env.API_URL_BASE + env.URL_UTENTI_AUTORIZZ_PROFILO;

  constructor(
    private http: HttpClient,
    private mapperUtente: MapperUtente,
    private modaleErroreStore: ModaleErroreStore
  ) { }

  getUtentiProfilo(
    cmu: string,
    profilo: string,
    autorizzazione?: string
  ): Observable<UtenteVO[]> {
    const headers = new HttpHeaders({ X_RTSYSID_APP: "PHYLUM" });
    let url = this.urlUtentiProfilo + profilo;
    if (cmu) {
      url = url + "&cmu=" + cmu;
    }
    if (autorizzazione) {
      url = url + "&autorizzazione=" + autorizzazione;
    }
    return this.http.get<UtenteDTO[]>(url, { headers: headers }).pipe(
      catchError(err => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      }),
      map((utenti: UtenteDTO[]) =>
        this.mapperUtente.convertListDtoToVo(utenti).sort((a, b) => {
          if (a.cognome < b.cognome) {
            return -1;
          } else if (a.cognome > b.cognome) {
            return 1;
          } else {
            if (a.nome < b.nome) {
              return -1;
            } else {
              return 1;
            }
          }
        })
      )
    );
  }

  getUtentiRedattoriAtto(cmu: string): Observable<UtenteVO[]> {
    return this.getUtentiProfilo(cmu, "REDAT");
  }


  getUtentiEstensori(cmu: string): Observable<UtenteVO[]> {
    return this.getUtentiProfilo(cmu, "FASC");
  }

  getUtentiConsultatori(cmu: string): Observable<UtenteVO[]> {
    return this.getUtentiProfilo(cmu, "LETT");
  }

  getUtentiResponsabili(cmu: string): Observable<UtenteVO[]> {
    return this.getUtentiProfilo(cmu, "FASC", "FIRMA");
  }
}
